import React from "react";

const DiscountChargeSection = ({ formik, subtotal = 0 }) => {
  const { values, setFieldValue } = formik;

  const handleSafeChange = (value) => {
    if (!/^\d*\.?\d*$/.test(value)) return;
    if (parseFloat(value) < 0) return;
    setFieldValue("overallDiscountPercent", value);
    const discountAmt = (subtotal * parseFloat(value || 0)) / 100;
    setFieldValue("overallDiscountAmount", discountAmt.toFixed(2));
  };

  const styles = `
  .bottom-section {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .discount-section-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
  }

  .form-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 16px 20px;
    flex: 1;
    min-width: 300px;
  }

  .form-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #444;
    margin-bottom: 8px;
  }

  .discount-group {
    position: relative;
    display: inline-block;
    width: 100px;
  }

  .discount-input {
    width: 100%;
    border: none;
    border-bottom: 1px solid #ccc;
    outline: none;
    font-size: 18px;
    font-weight: 600;
    text-align: right;
    background: transparent;
    padding-right: 25px;
  }

  .discount-symbol {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: 600;
    color: #444;
  }

  .save-block {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #555;
  }

  .save-block p {
    margin: 0;
    font-size: 14px;
  }

  .shortcut-text {
    font-size: 12px;
    color: #777;
    margin-top: 4px;
  }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="bottom-section">
        <div className="discount-section-container">
          <div className="form-card">
            <label className="form-label">OVERALL BILL DISCOUNT</label>
            <div className="discount-group">
              <input
                type="text"
                inputMode="decimal"
                value={values.overallDiscountPercent || ""}
                onChange={(e) => handleSafeChange(e.target.value)}
                className="discount-input"
                placeholder="0"
              />
              <span className="discount-symbol">%</span>
            </div>
          </div>

          <div className="form-card save-block">
            <p>
              Click on <strong>Save</strong> to Add Payment
            </p>
            <small className="shortcut-text">
              Use <strong>‘Alt+S’</strong> Key
            </small>
          </div>
        </div>
      </div>
    </>
  );
};

export default DiscountChargeSection;
